export interface WasData {
    score: number
    highScore: number
    mediumScore: number
    lowScore: number
    timestamp?: number
}

export interface WasValueReduxState {
    isFetching: boolean
    was: WasData
}

export const DEFAULT_WAS_VALUE_STATE: WasValueReduxState = {
    isFetching: true,
    was: {
        highScore: 0,
        mediumScore: 0,
        lowScore: 0,
        score: 0,
    },
}
